import React, { useState, useEffect } from 'react';
import axios from '../api/api';
import { Toaster, toast } from 'sonner';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import AuthToken from '../components/Context/AuthToken';
import logo from '../components/images/cf-logo-300x169.png'
import PropTypes from 'prop-types';

const Login = ({ setAccessToken }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { accessToken } = AuthToken();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = await axios.post('/auth/',
        { email, password }
      );
      setAccessToken(token);
      toast.success('Login Sucessful');
      navigate('/');
    } catch (error) {
      console.log(error);
      if (!error?.response.status) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 404) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Login failed.')
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken) {
      navigate('/');
    }
  });

  return (
    <main>
      <Toaster position='top-center' richColors />
      <div className='flex flex-wrap items-center justify-center gap-4 h-screen md:h-screen lg:h-[100vh]'>
        <div className='bg-white p-4 rounded-lg w-full md:w-2/3 lg:w-1/3 xl:w-1/4'>
          <form onSubmit={handleSubmit}>
            <div className='p-2 text-center'>
              <div className='flex items-center justify-center'>
                <span><img src={logo} alt="logo" /></span>
              </div>
              <h2 className='text-lg font-bold'>Welcome to Credo Faster Portal</h2>
              <p>Please login to your account to continue</p>
            </div>
            <div className='my-3'>
              <label htmlFor='email'><span>Email Address</span>
                <input
                  type='text'
                  required
                  placeholder='user@example.com'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            <div className="relative my-3">
              <label htmlFor="password" className="block">
                <span>Password</span>
                <div className="flex items-center">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    required
                    placeholder="********"
                    className="px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md sm:text-sm focus:ring-1"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 text-sm text-[#2b1e3e] focus:outline-none"
                    style={{ top: '70%', transform: 'translateY(-50%)' }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </label>
            </div>
            <div className='my-2'>
              <button disabled={loading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md w-full hover:bg-[#2b1e3e] disabled:bg-slate-500'>{loading ? 'Please Wait...' : 'Login'}</button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Login;

Login.propTypes = {
  setAccessToken: PropTypes.func
};
